<template>
  <div>
    <a-modal
      :title="'打印预览 - ' + reportTitle"
      :width="900"
      :visible="visible"
      :maskClosable="false"
      :forceRender="true"
      :footer="null"
      fullscreen
      switchFullscreen
      @cancel="handleCancel"
      wrapClassName="sales-ranking-print-modal"
    >
      <div class="print-toolbar" style="display:flex; align-items:center; gap:8px; margin-bottom:12px;">
        <a-button key="templateSetting" icon="setting" :disabled="autoPrint" @click="handleTemplateSetting">模板设置</a-button>
        <a-button key="printPreview" type="primary" icon="printer" @click="handlePrint">打印</a-button>
        
        <a-button key="exportPdf" icon="file-pdf" @click="handleExportPdf">导出PDF</a-button>
        <a-checkbox v-model="autoPrint" @change="onAutoPrintChange">自动</a-checkbox>
      </div>
      <a-spin :spinning="loading" tip="正在加载模板...">
        <div v-if="!templateJson && !loading" class="no-template">
          <a-empty description="暂无打印模板" />
        </div>
        <div v-else class="preview-wrapper">
          <div ref="printContent" class="print-content"></div>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import HiprintService from '@/services/hiprint-service'
import { loadTemplateWithFallback, getCurrentSystemInfo } from '@/api/plugin/print-template'
import { buildPrintData } from './salesRankingConfig'

export default {
  name: 'SalesRankingPrint',
  props: {
    visible: { type: Boolean, default: false },
    tableData: { type: Array, default: () => [] },
    queryParam: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      reportTitle: '销售排行',
      loading: false,
      templateJson: null,
      autoPrint: false,
      systemAutoPrint: false,
      companyInfo: {},
      userInfo: {}
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.init()
      }
    }
  },
  methods: {
    async init() {
      this.loading = true
      try {
        const store = this.$store || (window.Vue && window.Vue.prototype.$store)
        if (store && store.getters && store.getters.userInfo) {
          this.userInfo = store.getters.userInfo
        } else if (store && store.state && store.state.user && store.state.user.info) {
          this.userInfo = store.state.user.info
        }
        const tenantId = this.userInfo ? this.userInfo.tenantId : null

        const [templateResult, systemRes] = await Promise.all([
          loadTemplateWithFallback('SALES_RANKING', tenantId),
          getCurrentSystemInfo()
        ])

        if (templateResult && templateResult.templateJson && templateResult.templateJson.panels) {
          this.templateJson = templateResult.templateJson
        } else {
          console.warn('[SalesRankingPrint] 未找到打印模板')
          return
        }

        if (systemRes && systemRes.code === 200 && systemRes.data) {
          this.companyInfo = systemRes.data
          if (systemRes.data.autoPrint !== undefined && systemRes.data.autoPrint !== null) {
            this.autoPrint = (systemRes.data.autoPrint === '1')
            this.systemAutoPrint = (systemRes.data.autoPrint === '1')
          }
        }

        this.renderTemplate()

        this.$nextTick(() => {
          if (this.systemAutoPrint) {
            setTimeout(() => { this.handlePrint() }, 800)
          } else if (this.autoPrint) {
            setTimeout(() => { this.handlePrint() }, 800)
          }
        })
      } catch (error) {
        console.error('[SalesRankingPrint] 初始化失败:', error)
      } finally {
        this.loading = false
      }
    },

    renderTemplate() {
      if (!this.templateJson || !this.$refs.printContent) return
      const printData = buildPrintData(this.tableData, this.queryParam, this.userInfo, this.companyInfo)
      const html = HiprintService.renderHtml(this.templateJson, printData)
      if (html) {
        this.$refs.printContent.innerHTML = html
      }
    },

    handlePrint() {
      if (!this.$refs.printContent || !this.$refs.printContent.innerHTML) {
        this.$message.warning('暂无打印内容')
        return
      }
      const htmlContent = this.$refs.printContent.innerHTML
      const printWindow = window.open('', '_blank', 'width=900,height=600')
      if (!printWindow) {
        this.$message.warning('请允许浏览器弹出窗口')
        return
      }
      printWindow.document.write('<!DOCTYPE html><html><head><meta charset="utf-8"><title>' + this.reportTitle + '</title><link rel="stylesheet" type="text/css" media="print" href="' + window.location.origin + '/print-lock.css"><style>@page{margin:0}@media print{body{margin:0;padding:0}}body{-webkit-print-color-adjust:exact;print-color-adjust:exact}</style></head><body>' + htmlContent + '</body></html>')
      printWindow.document.close()
      printWindow.onload = () => {
        printWindow.print()
        printWindow.close()
      }
    },

    handleExportPdf() {
      if (!this.templateJson) {
        this.$message.warning('暂无模板数据')
        return
      }
      const hiprint = window.hiprint || (window.Vue && window.Vue.prototype.$hiprint)
      if (!hiprint || !hiprint.PrintTemplate) {
        this.$message.error('打印引擎未就绪')
        return
      }
      const printData = buildPrintData(this.tableData, this.queryParam, this.userInfo, this.companyInfo)
      const fileName = this.reportTitle + '_' + new Date().toISOString().slice(0, 10)
      const tempTemplate = new hiprint.PrintTemplate({ template: this.templateJson })
      tempTemplate.toPdf(printData, fileName, { scale: 2, useCORS: true })
    },

    handleTemplateSetting() {
      this.$emit('open-template-setting')
    },

    handleCancel() {
      this.autoPrint = false
      this.$emit('update:visible', false)
    },

    onAutoPrintChange(checked) {
      if (this.systemAutoPrint && !checked) {
        this.$message.info('全局自动打印已开启，不可关闭')
        this.autoPrint = true
      }
    }
  }
}
</script>

<style scoped>
.sales-ranking-print-modal >>> .ant-modal { top: 20px; height: 95%; }
.sales-ranking-print-modal >>> .ant-modal-body { height: calc(100% - 55px); overflow: auto; }
.preview-wrapper { background: #fff; min-height: 400px; }
.print-content { background: #fff; }
.no-template { padding: 80px 0; text-align: center; }
</style>